import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { UserServiceService } from "../../services/user-service/user-service.service";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { FormBuilder } from "@angular/forms";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import swal from "sweetalert2";

import {
  countryCodes,
  unitTypes,
  currencyCodes,
  etaTaxTypes,
  etaNonTacableTaxTypes,
  etaTaxSubtypes,
} from "../../../assets/eta-taxes-info";
import { Subject } from "rxjs";
import { set } from "date-fns";
import { catchError, debounceTime, switchMap, takeUntil } from "rxjs/operators";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-manage-eta-taxes",
  templateUrl: "./manage-eta-taxes.component.html",
  styleUrls: [
    "./manage-eta-taxes.component.css",
    "../../reservation/addreservation/addreservation.component.css",
  ],
})
export class ManageEtaTaxesComponent implements OnInit {
  title: string = "Add ETA Inovices";
  add_eta: any = {};
  etaId: any;
  agents: any;
  logo: any;
  isEditState = false;
  mode: any;
  eta: any;
  //#region

  current_eta: any;

  activitiesCodes: any;

  developers: any;

  countryCodes = countryCodes;
  activity_types = [];

  add_extra_tax_item: any = {};
  items: any = [];

  unitTypes = unitTypes;

  currencyCodes = currencyCodes;

  item_types: any = [];

  tax_types = [...etaTaxTypes, ...etaNonTacableTaxTypes];
  tax_subtypes = etaTaxSubtypes;
  tax_sub_types_match = [];

  getTypesSub: any;

  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();

  preview_model: any;

  current_developer;

  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  issuer_id;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private leadService: LeadsService,
    private fb: FormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    if (!this.canAccessEta()) {
      swal(
        "Insufficient Permissions!",
        "You do not have permission to access this page",
        "error"
      );
      this.router.navigate(["/pages/dashboard"]);
    }
  }

  canAccessEta() {
    return (
      this.userProfile.role == "Admin" ||
      this.userProfile.role == "A.R Accountant" ||
      this.userProfile.role == "Treasury Accountant" ||
      this.userProfile.is_tax_account ||
      this.userProfile.is_eta_user
    );
  }

  ngOnInit() {
    this.getdevelopers();
    this.getActivityCodes();
    this.getAllAgents();
    this.etaId = this.route.snapshot.params["id"];
    this.mode = this.route.snapshot.queryParams.mode;
    this.issuer_id = this.route.snapshot.queryParams.issuer_id;
    //console.log(this.mode);
    //console.log(this.etaId);
    //console.log(this.issuer_id);
    this.onCodeSearch();
    this.setDefaultValues();
  }

  getDataForSingleETA() {
    if (this.etaId > 0 || this.mode === "credit-notes") {
      this.isEditState = true;
      this.title = "Edit ETA Inovices";
      this.getETATax(this.etaId, this.issuer_id);
    }
  }

  setDefaultValues() {
    this.add_eta.receiver_country_code = "EG";
    this.add_eta.receiver_building_number = ".";
    this.add_eta.receiver_governate = "Cairo";
    this.add_eta.receiver_region_city = "Cairo";
    const now = new Date();

    // Get the timezone offset in minutes and adjust the time accordingly
    const timezoneOffset = now.getTimezoneOffset() * 60000; // Convert minutes to milliseconds

    // Adjust the date to the local time zone
    const localDatetime = new Date(now.getTime() - timezoneOffset);

    // Set seconds to 00
    localDatetime.setSeconds(0);

    // Format the datetime as a string that matches the `datetime-local` input format
    const formattedDatetime = localDatetime.toISOString().slice(0, 19);

    this.add_eta.invoice_datetime = formattedDatetime;
    this.add_extra_tax_item.unit_type = "EA";
    this.add_extra_tax_item.currency = "EGP";
    this.add_extra_tax_item.quantity = 1;
    this.add_extra_tax_item.item_discount_amount = 0;
    this.add_extra_tax_item.item_non_taxable_discount = 0;
    this.add_extra_tax_item.tax_type = "T1";
    this.onGetTaxTypeChange(this.add_extra_tax_item.tax_type);
  }

  onCodeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(2000), // Wait for 2 seconds of inactivity
        switchMap((keyword: string) => {
          //console.log(keyword);
          return this.leadService
            .getEtaTypes(
              this.add_extra_tax_item.item_type,
              keyword,
              this.add_eta.issuer_id
            )
            .pipe(
              catchError((error) => {
                //console.log("Error occurred:", error);
                return of([]); // Handle the error and return an empty array to continue the stream
              })
            );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (res) => {
          //console.log(res);
          this.item_types = res || [];
          //console.log(this.item_types);
          this.slimLoadingBarService.complete(); // Complete the loading bar on success
        },
        (err) => {
          //console.log("Subscription error:", err);
          this.slimLoadingBarService.complete(); // Complete the loading bar on error
        }
      );
  }

  getType(keyword: string): void {
    const type = this.add_extra_tax_item.item_type;
    if (!type || !this.add_eta.issuer_id) {
      this.item_types = [];
      return;
    }
    //console.log(keyword);
    this.slimLoadingBarService.start(); // Start the loading bar as soon as typing begins
    this.searchSubject.next(keyword);
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        //console.log(this.developers);
        this.getDataForSingleETA();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getActivityCodes() {
    this.activitiesCodes = this.leadService.getActivityCodes();
  }

  getAllAgents() {
    this.leadService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        //console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getETATax(uuid, issuer_id) {
    //console.log(issuer_id);
    this.leadService.getSingleEtaTax(uuid, issuer_id).subscribe(
      (data: any) => {
        //console.log(data);
        this.add_eta = {
          ...data,
        };
        this.items = data.invoice_lines.map((invoice) => {
          return {
            ...invoice,
            old_quantity: invoice.quantity,
            allowed_quantites: this.createNumberArray(
              +invoice.quantity
            ).reverse(),
          };
        });
        //console.log(this.items);
        this.current_developer = this.developers.find(
          (developer) => developer.id == this.issuer_id
        );
        this.add_eta.issuer_id = Number(this.issuer_id);
        //console.log(this.current_developer);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  // onQuantityChange(item) {
  //   this.items = this.items.map((curr) => {
  //     if (curr.id !== item.id) return curr;
  //     return {
  //       ...curr,
  //       old_quantity: item.old_quantity,
  //       quantity: item.old_quantity
  //     }
  //   })
  // }

  createNumberArray(start) {
    const result = [];

    for (let i = start; i >= 0; i--) {
      result.push(i);
    }

    return result;
  }

  adjustDateTime(dateTimeStr) {
    // Split the input date string into date and time components
    let [datePart, timePart] = dateTimeStr.split("T");
    let [hours, minutes] = timePart.split(":").map(Number);

    // Subtract 3 hours manually
    hours -= 3;

    // Handle the case where subtracting 3 hours goes into the previous day
    if (hours < 0) {
      hours += 24;
      // Move to the previous day
      const date = new Date(datePart);
      date.setDate(date.getDate() - 1);
      datePart = date.toISOString().split("T")[0];
    }

    // Get the current seconds
    const seconds = new Date().getSeconds();

    // Format the output as YYYY-MM-DDTHH:mm:ss
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${datePart}T${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  prepareAddEtaTax() {
    const date = this.add_eta.invoice_datetime;
    //console.log(date);
    const removed3hours = this.adjustDateTime(date);
    //console.log(removed3hours);
    // this.adjustDatetimeFormat();
    //console.log(this.items);
    let payload = {
      ...this.add_eta,
      invoice_lines: JSON.parse(
        JSON.stringify(
          this.items.map((item) => {
            return {
              ...item,
              quantity: Number(item.quantity),
            };
          })
        )
      ),
      quantity: Number(this.add_eta.quantity),
      item_price: Number(this.add_eta.item_price),
      item_non_taxable_discount: Number(this.add_eta.item_non_taxable_discount),
      invoice_datetime: this.adjustDateTime(date),
    };
    if (this.mode == "credit-notes") {
      payload.document_type = "credit";
      payload.reference_invoice_uuid = this.etaId;
    }
    //console.log(this.items);
    return payload;
  }

  addEtaTax() {
    const payload = this.prepareAddEtaTax();
    //console.log(payload);
    this.slimLoadingBarService.start();
    this.leadService.addEtaTax(payload).subscribe(
      (data) => {
        this.slimLoadingBarService.complete();
        // swal("Added ETA Tax successfully", "", "success");
        // window.history.back();
        this.preview_model = data;
        setTimeout(() => {
          window.scrollBy({
            top: 400, // Scroll down by 400px
            behavior: "smooth", // Optional: smooth scrolling
          });
        }, 2000);
      },
      (err) => {
        //console.log(err);
        this.errorHandlerService.handleErorr(err);
      },
      () => this.slimLoadingBarService.complete()
    );
  }

  ngOnDestroy() {
    this.current_eta = null;
    this.destroy$.next();
    this.destroy$.complete();
  }

  onIssuerChanged(event) {
    //console.log(event);
    this.activity_types = [];
    this.add_extra_tax_item.activity_type_code = null;
    this.current_developer = this.developers.find(
      (developer) => developer.id == event
    );
    if (this.current_developer) {
      this.activity_types = this.current_developer.activity_types;
      if (this.activity_types.length > 0) {
        this.add_eta.activity_type_code =
          this.activity_types[0].activity_type_code;
      }

      const maintenance_repair_service_item = this.current_developer.items.find(
        (item) => item.item_code == "EG-521131995-4"
      );
      //console.log(maintenance_repair_service_item);
      if (maintenance_repair_service_item) {
        this.add_extra_tax_item.item_code =
          maintenance_repair_service_item.item_code;
      } else {
        this.add_extra_tax_item.item_code = null;
      }
    }
  }

  addItem() {
    const developer = this.developers.find(
      (developer) => developer.id == this.add_eta.issuer_id
    );
    const item = developer.items.find(
      (item) => item.item_code == this.add_extra_tax_item.item_code
    );
    //console.log(item);
    this.items.push({
      ...this.add_extra_tax_item,
      tax_rate: Number(this.add_extra_tax_item.tax_rate),
      item_code: String(this.add_extra_tax_item.item_code),
      item_exchange_rate: Number(this.add_extra_tax_item.item_exchange_rate),
      item_type: item.item_type,
    });
    this.add_extra_tax_item = {
      unit_type: "EA",
      currency: "EGP",
      quantity: 1,
      item_discount_amount: 0,
      item_non_taxable_discount: 0,
      add_extra_tax_item: "T1",
    };
    //console.log(this.items);
  }

  onGetItemTypeChange(event) {
    this.add_extra_tax_item.item_code = null;
  }

  deleteItem(index) {
    this.items.splice(index, 1);
  }

  onGetTaxTypeChange(event) {
    //console.log(event);
    //console.log(this.tax_subtypes);
    this.tax_sub_types_match = [];
    this.add_extra_tax_item.tax_sub_type = null;
    this.tax_sub_types_match = this.tax_subtypes.filter(
      (type: any) => type.taxtypeReference == event
    );
    const tax_type_item = this.tax_types.find(
      (type: any) => type.code == this.add_extra_tax_item.tax_type
    );
    if (tax_type_item && tax_type_item.desc_ar == "ضريبه القيمه المضافه") {
      this.add_extra_tax_item.tax_rate = 14;
      this.add_extra_tax_item.tax_sub_type = "V009";
    } else {
      this.add_extra_tax_item.tax_rate = 0;
      this.add_extra_tax_item.tax_sub_type = null;
    }
    //console.log(this.tax_sub_types_match);
  }

  confirmEtaTaxAfterPreview() {
    swal({
      title: "Are you sure?",
      text: "You will submit this ETA Inovice!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        // const payload = {
        //   ...this.eta
        // };
        const payload = this.prepareAddEtaTax();
        //console.log(payload);
        this.slimLoadingBarService.start();
        this.leadService.confirmEtaInovice(payload).subscribe(
          (res: any) => {
            this.slimLoadingBarService.complete();
            swal(
              "Woohoo!",
              "updated Eta Inovice submitted successfully!",
              "success"
            );
            // window.history.back();
            this.router.navigate(["/pages/financial/eta-taxes"]);
          },
          (err) => {
            //console.log(err);
            if (err.error && err.error.message) {
              swal("error", err.error.message, "error");
            }
            this.slimLoadingBarService.reset();
          }
        );
      }
    });
  }

  getItem(item) {
    const find_item = this.current_developer.items.find(
      (x) => x.item_code == item.item_code
    );
    if (!find_item) return "";
    return find_item.item_name_ar;
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/manage-eta-taxes/manage-eta-taxes.component.ts